// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"df54a366","453":"bfd56f49","958":"bad8c783"}[chunkId] + ".chunk.js";
};